// extracted by mini-css-extract-plugin
module.exports = {"AddNewRatingPoint":"AddNewRatingPoint_AddNewRatingPoint__u2A_C","AddNewRatingPoint-Title":"AddNewRatingPoint_AddNewRatingPoint-Title__3qqFA"};